import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    personalRatingData: [],
    loadingPersonalRatingData: false,
    isGroupHead: false,
    loadingIsGroupHead: false,
    whoCanNote: [],
    loadingWhoCanNote: false,
    waitingForSendAssignResponsible: false,
    waitingForSendCreateOmission: false
};

const loadPersonalRatingData = (state) => {
    return {
        ...state,
        loadingPersonalRatingData: true
    }
}

const setPersonalRatingData = ( state, action ) => {
    let tmp = {...action.personalRatingData}
    return {
        ...state,
        personalRatingData: tmp,
        loadingPersonalRatingData: false
    }
};

const loadGroupHead = (state) => {
    return {
        ...state,
        loadingIsGroupHead: true
    }
}

const setGroupHead = ( state, action ) => {
    let tmp = action.isGroupHead
    return {
        ...state,
        isGroupHead: tmp,
        loadingIsGroupHead: false
    }
};

const loadWhoCanNote = (state) => {
    return {
        ...state,
        loadingWhoCanNote: true
    }
}

const setWhoCanNote = ( state, action ) => {
    return {
        ...state,
        whoCanNote: [...action.whoCanNote],
        loadingWhoCanNote: false
    }
};

const sendAssignResponsible = (state) => {
    return {
        ...state,
        waitingForSendAssignResponsible: true
    }
}

const receiveSendAssignResponsible = (state) => {
    return {
        ...state,
        waitingForSendAssignResponsible: false,
    }
}

const sendCreateOmission = (state) => {
    return {
        ...state,
        waitingForSendCreateOmission: true
    }
}

const receiveSendCreateOmission = (state) => {
    return {
        ...state,
        waitingForSendCreateOmission: false,
    }
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_PERSONAL_RATING_DATA: return loadPersonalRatingData( state );
        case actionTypes.SET_PERSONAL_RATING_DATA: return setPersonalRatingData( state, action );
        case actionTypes.LOAD_IS_GROUP_HEAD: return loadGroupHead( state );
        case actionTypes.SET_IS_GROUP_HEAD: return setGroupHead( state, action );
        case actionTypes.LOAD_WHO_CAN_NOTE: return loadWhoCanNote( state );
        case actionTypes.SET_WHO_CAN_NOTE: return setWhoCanNote( state, action );
        case actionTypes.SEND_ASSIGN_RESPONSIBLE: return sendAssignResponsible( state );
        case actionTypes.RECEIVE_SEND_ASSIGN_RESPONSIBLE: return receiveSendAssignResponsible( state );
        case actionTypes.SEND_CREATE_OMISSION: return sendCreateOmission( state );
        case actionTypes.RECEIVE_CREATE_OMISSION: return receiveSendCreateOmission( state );
        default: return state;
    }
};
export default reducer;